import {
  GenericNotificationProps,
  StepCounter,
  TypedVueformSchema,
} from '@digitale-verhuurders-verklaring/core/src/models/frontend/forms/types';
import { Name } from '@digitale-verhuurders-verklaring/core/src/models/shared/schema';
import { push } from 'notivue';
import { Ref } from 'vue';
import { useI18n } from 'vue-i18n';
export const toBase64String = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
  });

export const setStepLabel = <T>(
  form$: Ref<TypedVueformSchema<T> | null>,
  stepCounter: Ref<StepCounter>,
) => {
  const { t } = useI18n();
  //eslint-disable
  form$.value?.steps$.on(
    'select',
    (value: { index: number; stepLabel: string; steps$: any }) => {
      // No need to iterate since visible$ is an object
      const visibleSteps = value.steps$.visible$;
      // Get array of keys and find the index
      const stepIndex = Object.keys(visibleSteps).findIndex(
        (key) => visibleSteps[key]?.stepLabel === value.stepLabel,
      );
      if (stepIndex !== -1) {
        stepCounter.value = {
          currentStep: `${(stepIndex + 1).toString()}. ${value.stepLabel}`,
          stepCount: t('message.global.step.stepCount', {
            step: stepIndex + 1,
            total: Object.keys(visibleSteps).length,
          }),
        };
      }
    },
  );
  //eslint-enable
};

// Wrapper for notivue push function that adds more specific typing
export const toast = {
  success: (options: GenericNotificationProps) => push.success(options),
  error: (options: GenericNotificationProps) => push.error(options),
  // Note: info and warning are not yet implemented in GenericNotification
  // Info: (options: GenericNotificationProps) => push.info(options),
  // Warning: (options: GenericNotificationProps) => push.warning(options),
};

// Get the full name of the tenant based on the first, infix and last name
export const getFullName = (person: Name) => {
  const parts = [
    person.firstName ?? '',
    person.infix ?? '',
    person.lastName ?? '',
  ].filter((part) => part.trim());

  return parts.join(' ');
};
// From https://stackoverflow.com/a/78924733/11366805
// Has been modified to remove the last part, which checks by using the Date object
// Thus, only accepts simple ISO date strings, AKA those made with new Date().toISOString()
export const simpleIsoDateTransformer = (isoString: string): boolean => {
  return /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(isoString);
};
